export default __webpack_public_path__ + "static/omni-banner-67678c55eb05ef43e9582568109f2854.webp";